const DEFAULT_IMAGE_TYPE = "image/jpeg";
const DEFAULT_IMAGE_QUALITY = 0.92;

/**
 * 将实时 video 的原始分辨率画到 canvas，并编码成静态预览 Blob。
 * 检测使用低分辨率采样 canvas；这里使用独立 canvas，避免降低最终图片清晰度。
 */
export const captureVideoFrame = (
  video,
  canvas,
  { imageType = DEFAULT_IMAGE_TYPE, imageQuality = DEFAULT_IMAGE_QUALITY } = {},
) =>
  new Promise((resolve, reject) => {
    if (!video?.videoWidth || !video?.videoHeight || !canvas) {
      reject(new Error("The camera frame is unavailable."));
      return;
    }

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error("The camera frame could not be captured."));
      },
      imageType,
      imageQuality,
    );
  });
